import React from "react";
import classes from "./TabContent.module.css";

const TabContent = ({ content }: { content: JSX.Element }) => {
  return <div className={classes.content}>{content}</div>;
};

export default TabContent;
